import BlankLayout from "layout/BlankLayout";
import { Link } from "react-router-dom";

const Home = () => {
  return (
    <BlankLayout>
      <>
        <div className="section">
          <div className="container">
            <div className="intro-wrap">
              <h1 className="heading-jumbo">
                Hey there! <br />
                <br />
                We invite you to explore our{" "}
                <strong>STEM activities recommender </strong>and let us know
                what you think about it.{" "}
              </h1>
              <div className="text-block">
                Our goal is to <strong>personalize a learning plan</strong> for
                you that answers the question{" "}
                <strong>
                  &quot;what should I learn next?&quot; <br />
                  <br />‍
                </strong>
                To start, we will ask you a few questions to help us understand
                more about what you like.Then we will present you with three options
                that best match your interests and learning goals. <br />
                <br />
                Your feedback will help us improve the application and ensure
                our recommendations are accurate. <br />
                <br />
                <strong></strong>Please do these activities with your parent or
                guardian.
              </div>
            </div>
          </div>
        </div>
        <div className="container-2 w-container">
          <Link to="/interest-selection" className="button-2 w-button">
            BEGIN STUDY
          </Link>
        </div>
      </>
    </BlankLayout>
  );
};

export default Home;
